export const ROUTE_PATH = {
  HOME: {
    TEXT: 'Home',
    LINK: '/home',
  },
  LOGIN: {
    TEXT: 'Login',
    LINK: '/login',
  },
  USER_MANAGEMENT_BUYER: {
    TEXT: 'User Management',
    LINK: '/user-management-buyer',
  },
  USER_MANAGEMENT_ADMIN: {
    TEXT: 'User Management',
    LINK: '/user-management-admin',
  },
  USER_MANAGEMENT_SUPPLIER: {
    TEXT: 'User Management',
    LINK: '/user-management-supplier',
  },
  USER_DETAIL_FORM_BUYER: {
    TEXT: 'user Detail Form',
    LINK: '/user-detail-form-buyer',
  },
  USER_DETAIL_FORM_ADMIN: {
    TEXT: 'user Detail Form',
    LINK: '/user-detail-form-admin',
  },
  USER_DETAIL_FORM_SUPPLIER: {
    TEXT: 'user Detail Form',
    LINK: '/user-detail-form-supplier',
  },
  USER_EDIT_FORM_BUYER: {
    TEXT: 'user Edit Form',
    LINK: '/user-edit-form-buyer:id',
    PATH: '/user-edit-form-buyer',
  },
  USER_EDIT_FORM_ADMIN: {
    TEXT: 'user Edit Form',
    LINK: '/user-edit-form-admin:id',
    PATH: '/user-edit-form-admin',
  },
  USER_EDIT_FORM_SUPPLIER: {
    TEXT: 'user Edit Form',
    LINK: '/user-edit-form-supplier:id',
    PATH: '/user-edit-form-supplier',
  },
  BANNER_MANAGEMENT: {
    TEXT: 'Banner Management',
    LINK: '/banner-management',
  },
  BANNER_DETAIL_FORM: {
    TEXT: 'Banner Detail Form',
    LINK: '/banner-detail-form',
  },
  BUYER_MANAGEMENT: {
    TEXT: 'Buyer Management',
    LINK: '/buyer-management',
  },
  BUYER_DETAIL_FORM: {
    TEXT: 'Buyer Detail Form',
    LINK: '/buyer-detail-form',
  },
  BUYER_EDIT_FORM: {
    TEXT: 'Buyer Detail Form',
    LINK: '/buyer-edit-form:id',
    PATH: '/buyer-edit-form',
  },
  UPLOAD_SUSTAINABILITY_BUYER: {
    TEXT: 'Sustainability',
    LINK: '/upload-sustainability-form-buyer',
  },
  CATEGORY_MANAGEMENT: {
    TEXT: 'Category Management',
    LINK: '/category-management',
  },
  CATEGORY_BUSINESS_GROUP_FORM: {
    TEXT: 'Category Business Group Form',
    LINK: '/category-business-group-form',
  },
  CATEGORY_SERVICE_GROUP_FORM: {
    TEXT: 'Category Service Group Form',
    LINK: '/category-service-group-form',
  },
  COMPANY_PROFILE_FORM_BUYER: {
    TEXT: 'Company Profile Form',
    LINK: '/company-profile-buyer-form',
  },
  COMPANY_PROFILE_FORM_SUPPLIER: {
    TEXT: 'Company Profile Form',
    LINK: '/company-profile-supplier-form',
  },
  SUPPLIER_DETAIL_FORM_ADMIN: {
    TEXT: 'Supplier Detail From | Admin',
    LINK: '/supplier-detail-form-admin',
  },
  SUPPLIER_DETAIL_FORM_ADMIN_REJECT: {
    TEXT: 'Supplier Detail From',
    LINK: '/supplier-detail-form-admin-reject:id',
    PATH: '/supplier-detail-form-admin-reject',
  },
  SUPPLIER_EDIT_FORM_ADMIN: {
    TEXT: 'Supplier Edit From',
    LINK: '/supplier-edit-form-admin:id',
    PATH: '/supplier-edit-form-admin',
  },
  SUPPLIER_EDIT_FORM_ADMIN_WAIT_ACTIVE: {
    TEXT: 'Supplier Edit From',
    LINK: '/supplier-edit-form-admin-wait-active:id',
    PATH: '/supplier-edit-form-admin-wait-active',
  },
  SUPPLIER_EDIT_FORM_ADMIN_WAIT_APPROVE: {
    TEXT: 'Supplier Edit From',
    LINK: '/supplier-edit-form-admin-wait-approve:id',
    PATH: '/supplier-edit-form-admin-wait-approve',
  },
  SUPPLIER_DISCOVERY: {
    TEXT: 'Supplier Discovery',
    LINK: '/supplier-discovery',
  },
  SUPPLIER_DISCOVERY_INFORMATION: {
    TEXT: 'Supplier Discovery information',
    LINK: '/supplier-discovery-information/:id',
  },
  SUPPLIER_MANAGEMENT_INFORMATION_EDIT: {
    TEXT: 'Supplier Management information Edit',
    LINK: '/supplier-management-information-edit:id',
    PATH: '/supplier-management-information-edit',
  },
  SUPPLIER_MANAGEMENT_ADMIN: {
    TEXT: 'Supplier Management | Admin',
    LINK: '/supplier-management-admin',
  },
  SUPPLIER_MANAGEMENT_BUYER: {
    TEXT: 'Supplier Management | Buyer',
    LINK: '/supplier-management-buyer',
  },
  SUPPLIER_MANAGEMENT_FORM_BUYER: {
    TEXT: 'Supplier Management | Buyer',
    LINK: '/upload-supplier-form-buyer',
  },
  SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT: {
    TEXT: 'Sustainability Pre-Assessment Management',
    LINK: '/sustainability-pre-assessment-management',
  },
  UPLOAD_SUSTAINABILITY_PRE_ASSESSMENT_FORM_ADMIN: {
    TEXT: 'Sustainability Pre-Assessment Form | Admin',
    LINK: '/upload-sustainability-pre-assessment-form-admin',
  },
  ACTIVATED_ACCOUNT: {
    TEXT: 'Activate Account',
    LINK: '/activate-account/:date/:token',
  },
  CONTACT_ADMIN: {
    TEXT: 'Contact Admin',
    LINK: '/contact-admin',
  },
  RESEND_EMAIL: {
    TEXT: 'Resend Activate Email',
    LINK: '/resend-email',
  },
  RESET_PASSWORD: {
    TEXT: 'Reset Password',
    LINK: '/reset-password/:date/:token',
  },
  UPLOAD_SUPPLIER_FORM: {
    TEXT: 'upload supplier form',
    LINK: '/upload-supplier-form',
  },
  UPLOAD_SUPPLIER_FORM_BUYER: {
    TEXT: 'upload supplier form buyer',
    LINK: '/upload-supplier-form-buyer',
  },
  ANNOUNCEMENT_MANAGEMENT: {
    TEXT: 'Announcement Management',
    LINK: '/announcement-management',
  },
  ANNOUNCEMENT_DETAIL_FORM: {
    TEXT: 'Announcement detail form',
    LINK: '/announcement-detail-form',
  },
  ESG_VERIFICATION: {
    TEXT: 'ESG Verification',
    LINK: '/esg-verification',
  },
  ESG_VERIFICATION_DETAIL_FORM: {
    TEXT: 'ESG Verification Detail Form',
    LINK: '/esg-verification-detail-form',
  },
  COMPREHENSIVE_ASSESSMENT_MANAGEMENT: {
    TEXT: 'Comprehensive Assessment Management',
    LINK: '/comprehensive-assessment-management',
  },
  UPLOAD_COMPREHENSIVE_ASSESSMENT: {
    TEXT: 'Upload Comprehensive Assessment',
    LINK: '/upload-comprehensive-assessment',
  },
  RISK_MANAGEMENT: {
    TEXT: 'Risk Management',
    LINK: '/risk-management',
  },
  SUPPLIER_REGISTRATION_FORM: {
    TEXT: 'Supplier Registration Form',
    LINK: '/supplier-registration-form/:date/:key',
  },
  LINK_TOKEN_EXPIRED: {
    TEXT: 'link token expired',
    LINK: '/link-token-expired',
  },
  SOURCING_BUYER: {
    TEXT: 'Sourcing',
    LINK: '/sourcing-buyer',
  },
  SOURCING_PROJECTS: {
    TEXT: 'Sourcing Projects',
    LINK: '/sourcing-projects',
  },
  SOURCING_PROJECT_DETAIL: {
    TEXT: 'Sourcing Project detail',
    LINK: '/sourcing-project-detail/:id',
  },
  SOURCING_DETAIL_BUYER_FORM: {
    TEXT: 'Sourcing Detail Form',
    LINK: '/sourcing-detail-form-buyer',
  },
  SOURCING_DETAIL_BUYER_FORM_EDIT: {
    TEXT: 'Sourcing Detail Form',
    LINK: '/sourcing-detail-form-buyer/:id/:eventid?',
  },
  SOURCING_DETAIL_BUYER_FORM_COPYCREATE_EDIT: {
    TEXT: 'Sourcing Detail Form',
    LINK: '/sourcing-detail-form-buyer-cocr-edit/:id/:eventid?',
  },
  SOURCING_DETAIL_BUYER_FORM_COPYCREATE: {
    TEXT: 'Sourcing Detail Form',
    LINK: '/sourcing-detail-form-buyer-cocr/:idproject?/:eventid?',
  },
  SOURCING_COMPARE_EVENTS: {
    TEXT: 'Sourcing Compare Events',
    LINK: '/sourcing-compare-events/:id/:rfqid/:eventType',
  },
  SOURCING_CREATE_NEWROUND: {
    TEXT: 'Sourcing Create New Round',
    LINK: '/sourcing-create-new-round-form-buyer/:createnewround/:id/:eventid?',
  },
  SOURCING_DETAIL_BUYER_FORM_EVENT_EDIT: {
    TEXT: 'Sourcing Detail Form',
    LINK: '/sourcing-detail-form-event-buyer/:id/:eventid?',
  },
  SOURCING_DETAIL_BUYER_FORM_EVENTS_EDIT: {
    TEXT: 'Sourcing Detail Form',
    LINK: '/sourcing-detail-form-events-buyer/:id/:eventid?',
  },
  SOURCING_COMPARE_EVENT: {
    TEXT: 'Sourcing Compare Event',
    LINK: '/sourcing-compare-event/:id/:rfqid/:eventType',
  },
  SOURCING_SUPPLIER: {
    TEXT: 'Sourcing',
    LINK: '/sourcing-supplier',
  },
  SOURCING_AUCTION_BUYER: {
    TEXT: 'Sourcing',
    LINK: '/sourcing-auction-buyer/:sourcingid',
  },
  SOURCING_AUCTION_SUPPLIER: {
    TEXT: 'Sourcing',
    LINK: '/sourcing-auction-supplier/:sourcingid',
  },
  SOURCING_DETAIL_SUPPLIER_FORM: {
    TEXT: 'Sourcing Detail Form',
    LINK: '/sourcing-detail-form-supplier/:id',
  },
  UPLOAD_REGULATORY: {
    TEXT: 'Regulatory',
    LINK: '/upload-regulatory',
  },
  ONLINE_TEMPLATE_MANEGEMENT: {
    TEXT: 'Create New Template',
    LINK: '/online-template-management',
  },
  SUPPLIER_ONLINE_TEMPLATE_MANAGEMENT: {
    TEXT: 'Online Comprehensive Assessment Management',
    LINK: '/supplier-online-form-management',
  },
  // SUPPLIER_ONLINE_TEMPLATE_MANAGEMENT_DISPLAY: {
  //   TEXT: 'Online Comprehensive Assessment Management',
  //   LINK: '/supplier-online-form-management/:templateId/:supplierId/:type',
  // },
  SUPPLIER_ONLINE_TEMPLATE_MANAGEMENT_MAIL: {
    TEXT: 'Online Comprehensive Assessment Management',
    LINK:
      '/supplier-online-form-management/:templateId/:supplierId/:requestDate',
  },
  BUYER_ONLINE_TEMPLATE_MANAGEMENT: {
    TEXT: 'Online Comprehensive Assessment Management',
    LINK:
      '/buyer-online-form-management/:templateId/:supplierId/:versionResponded/:versionTemplate',
  },

  //Test components
  TEST_PAGE: {
    TEXT: 'test page',
    LINK: '/test-page',
  },

  LINK_HAVE_ACCOUNT: {
    TEXT: 'link have account',
    LINK: '/link-have-account',
  },
  RFQ_COPY_DETAIL: {
    TEXT: 'rfq copy detail by id',
    LINK: '/supplier-sourcing-detail-form-buyer',
  },
  TIPS_AND_TUTORIAL_ENGLISH_AUCTION: {
    TEXT: 'User Guideline English Auction',
    LINK: '/user-guideline/english-auction',
  },
  TIPS_AND_TUTORIAL_RFQ: {
    TEXT: 'User Guideline RFQ',
    LINK: '/user-guideline/rfq',
  },
}

// export const ROUTE_ROLE = {
//   BUYER: {
//     LINK: '/buyer',
//   },
//   SUPPLIER: {
//     LINK: '/supplier',
//   },
//   ADMIN: {
//     LINK: '/admin',
//   }
// }

export const ROUTE_PUBLIC_PATH = [
  ROUTE_PATH.LOGIN.LINK,
  ROUTE_PATH.ACTIVATED_ACCOUNT.LINK,
  ROUTE_PATH.CONTACT_ADMIN.LINK,
  ROUTE_PATH.RESEND_EMAIL.LINK,
  ROUTE_PATH.RESET_PASSWORD.LINK,
  ROUTE_PATH.SUPPLIER_REGISTRATION_FORM.LINK,
  ROUTE_PATH.LINK_TOKEN_EXPIRED.LINK,
  ROUTE_PATH.LINK_HAVE_ACCOUNT.LINK,
  ROUTE_PATH.LOGIN.LINK,
]
